import { useCallback, useState } from 'react'

import { ConversationBootstrapModes } from '../../hooks/useConversationStream'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'

export const useGlobalCommandView = () => {
  const { conversationBootstrap, openConversation, endConversation } =
    useGlobalSearch()
  const [isGuidedIntakePromoOpen, setIsGuidedIntakePromoOpen] = useState(false)

  const startConversation = useCallback(
    (query: string) => {
      openConversation({
        mode: ConversationBootstrapModes.NEW,
        initialQuery: query,
      })
    },
    [openConversation]
  )

  const resumeConversation = useCallback(
    (conversationId: string) => {
      openConversation({
        mode: ConversationBootstrapModes.RESUME,
        conversationId,
      })
    },
    [openConversation]
  )

  const openGuidedIntakePromo = useCallback(() => {
    setIsGuidedIntakePromoOpen(true)
  }, [])

  const closeGuidedIntakePromo = useCallback(() => {
    setIsGuidedIntakePromoOpen(false)
  }, [])

  return {
    data: { bootstrap: conversationBootstrap },
    states: { isGuidedIntakePromoOpen },
    methods: {
      startConversation,
      resumeConversation,
      endConversation,
      openGuidedIntakePromo,
      closeGuidedIntakePromo,
    },
  }
}
